import { RoutePath } from '@components/AppRouter/constants';
import { dictionaryConfig } from '@components/AppRouter/menuConfig/routes/dictionaryConfig';
import { keycloak } from '@src/auth';

import type { Route } from '../types';

/*
не меняйте последовательность, дизайн ориентируется на ключи в массиве
 */

const { logout } = keycloak;

export const menuConfig: Route[] = [
  { ...dictionaryConfig, key: 'dictionary' },
  {
    title: 'Реестр подготовки отчетности',
    icon: 'calculationModuleHome',
    key: 'publication',
    path: RoutePath.PREPARATION_OF_REPORTS,
    resourceName: 'CmPublicationRegister',
  },
  {
    path: RoutePath.REPORTING_TREE,
    title: 'Просмотр отчетности',
    key: 'tree',
    icon: 'reportingTreeHome',
    resourceName: 'CmCompanyReport',
  },
  {
    title: 'Результаты выполнения КП',
    icon: 'dataControlHomeIcon',
    key: 'dataControl',
    path: RoutePath.DATA_CONTROL,
    resourceName: 'CmCtrlResults',
  },
  {
    title: 'Мониторинг фоновых процессов',
    icon: 'logsHome',
    path: RoutePath.LOGS,
    key: 'etlProcess',
    resourceName: 'CmEtlProcess',
  },
  {
    title: 'Безопасность',
    icon: 'userRoleReportHome',
    key: 'security',
    resourceName: ['CmAdministration'],
    routes: [
      {
        title: 'Отчет по ролям пользователей',
        path: RoutePath.USER_ROLE_REPORT,
        resourceName: 'CmAdministration',
      },
      {
        title: 'Аудит действий пользователей',
        path: RoutePath.AUDIT,
        resourceName: 'CmAdministration',
      },
    ],
  },
  {
    title: 'Личный кабинет',
    icon: 'privateOfficeHome',
    key: 'workplace',
    resourceName: ['CmWorkplace'],
    routes: [
      {
        title: 'Данные пользователя',
        path: RoutePath.ACCOUNT,
        resourceName: 'CmWorkplace',
      },
      {
        title: 'Выйти из профиля ',
        path: 'logout',
        withTopDivider: true,
        onClick: logout,
      },
    ],
  },
];
